import type { LocaleStrings } from "../types.ts";

export const zhLocale: LocaleStrings = {
  game: {
    defaultClanName: "你的部族",
    clanSetupTitle: "创建部族",
    clanSetupNameLabel: "部族名称",
    clanSetupNamePlaceholder: "输入名称",
    clanSetupConfirm: "确认",
    settleConfirm: "继续",
    promptConfirmStart: "在这里开始？",
    startTileConfirm: "确认",
    startTileCancel: "取消",
    clanSetupTotemLabel: "图腾",
    promptClanSetup: "为部族命名，选择图腾并确认，然后选择起始地块。",
    statsHeaderFormat: "{clanName} · {turnLabel} {turn}",
    promptSelectStart: "选择部族的起始地块。",
    promptClanEstablished: "部族已建立。",
    promptEndTurn: "准备好后结束回合。",
    promptNewTurn: "移动到相邻地块或结束回合。",
    promptVictory: "你的部族繁荣昌盛！",
    promptDefeat: "你的部族已陷入饥荒。",
    tileContentsFormat: "{terrain} — 每回合 {food} 食物",
    tileContentsReducedFormat: "{terrain} — 每回合 {effective}/{base} 食物",
    tileTravelingFormat: "{terrain} — 行进中，本回合不收获",
    turnLabel: "回合",
    dayNightLabels: {
      day: "白天",
      dusk: "黄昏",
      night: "夜晚",
      dawn: "黎明",
    },
    seasonLabels: {
      spring: "春季",
      summer: "夏季",
      autumn: "秋季",
      winter: "冬季",
    },
    temperatureFormat: "{value}°C",
    weatherLabels: {
      clear: "晴朗",
      cloudy: "多云",
      overcast: "阴天",
      rainy: "下雨",
      snowy: "下雪",
    },
    populationLabel: "人口",
    foodLabel: "食物",
    waterLabel: "水",
    ambientPredatorsLabel: "掠食者",
    ambientPredatorLevelLabels: {
      none: "无",
      low: "低",
      medium: "中",
      high: "高",
    },
    populationProgressFormat: "{current} / {max}",
    foodGrowthHintFormat: "→ {threshold} 时增长",
    statsCollapsedChipFormat: "第 {turn} 回合 · {population} · {food} · {water} · {predators}",
    endTurnLabel: "结束回合",
    terrainNames: {
      ["desert"]: "沙漠",
      ["mountain"]: "山地",
      ["swamp"]: "沼泽",
      ["forest"]: "森林",
      ["plains"]: "平原",
      ["river"]: "河流",
    },
    totemNames: {
      carved: "雕刻",
      antler: "鹿角",
      spiral: "螺旋",
    },
    victoryTitle: "胜利！",
    victoryMessage: "你的部族已发展到 30 人。真正的文明就此开始。",
    victoryRecapLineFormat: "{label}：{value}",
    victoryRecapTurns: "胜利回合数",
    victoryRecapPopulation: "人口",
    victoryRecapFood: "食物",
    victoryRecapStartTerrain: "起始地形",
    victoryRecapEndTerrain: "最终地形",
    victoryRecapExplored: "地图探索",
    victoryRecapExploredFormat: "{explored} / {total} 格",
    defeatTitle: "失败",
    defeatMessage: "你的族人已全部离去。",
    startAgain: "重新开始",
    resetLabel: "重置",
    exitGame: "退出游戏",
    settingsTitle: "设置",
    settingsCloseAriaLabel: "关闭设置",
    languageLabel: "语言",
    sfxVolumeLabel: "音效 — {level}",
    debugModeOff: "调试模式关",
    debugModeOn: "调试模式开",
    fullscreenOff: "全屏关",
    fullscreenOn: "全屏开",
    foodOverlayOff: "在地图上显示食物",
    foodOverlayOn: "在地图上隐藏食物",
    waterOverlayOff: "在地图上显示水",
    waterOverlayOn: "在地图上隐藏水",
    promptBannerHide: "隐藏提示横幅",
    promptBannerShow: "显示提示横幅",
    stagingBadgeLabel: "预发",
    hudSettingsTooltip: "打开设置",
    hudNotificationsTooltip: "打开通知",
    notificationMarkDone: "标记为已完成",
    notificationOk: "确定",
    notificationCancel: "取消",
    closeAriaLabel: "关闭",
    leaveConfirmTitle: "保存并离开？",
    leaveConfirmBody: "你的进度将被保存。你可以从标题画面继续此游戏。",
    leaveConfirmSave: "保存并离开",
    leaveConfirmStay: "继续游戏",
    leaveConfirmSaveFailed: "无法保存游戏。请释放浏览器存储空间后重试。",
    notificationEmpty: "目前没有通知。",
    notificationPageOf: "{current} / {total}",
    notificationPageIndicatorOf: "（{current} / {total}）",
    notificationSwampTitle: "沼泽地",
    notificationSwampBody: "你的部族进入了沼泽。地面潮湿，在这里前进感觉更慢。",
    notificationFireTitle: "发现火",
    notificationFireBody: "你的部族在这片格子上发现了火——探索地图时的罕见发现。",
    notificationFoodDepletionTitle: "土地已贫瘠",
    notificationFoodDepletionBody:
      "停留在同一地块会降低其食物产量。继续迁徙，让土地随时间恢复。",
    notificationTutorialTurnsTitle: "你的第一回合",
    notificationTutorialTurnsBody: "移动到相邻地块，或在准备好后结束回合。",
    notificationTutorialStatsTitle: "部族数据",
    notificationTutorialStatsBody:
      "左上角面板显示回合、时段、季节、温度、天气、人口、食物、水以及当前地块的掠食者。准备好采集并推进时，按 E 或点击结束回合。",
    notificationTutorialWinGoalTitle: "如何获胜",
    notificationTutorialWinGoalBody: "将部族发展到 30 人即可获胜。若人口归零，部族将灭亡。",
    notificationTutorialFoodEconomyTitle: "每回合食物",
    notificationTutorialFoodEconomyBody:
      "结束回合时，当前格子产出食物。人口先消耗——剩余部分计入或扣除储存的食物。",
    notificationTutorialTileFoodTitle: "阅读格子信息",
    notificationTutorialTileFoodBody:
      "每个已揭示格子显示地形和每回合食物。定居前先探索——平原、河流等富饶地形能支撑更久。",
    notificationTutorialGrowthTitle: "人口增长",
    notificationTutorialGrowthBody: "储存的食物连续若干回合保持充足时，人口会增加 1。",
    notificationTutorialFamineTitle: "饥饿",
    notificationTutorialFamineBody:
      "若部族连续饥饿太久，会失去 1 人。迁往肥沃格子并积累储备。",
    notificationTutorialOneMoveTitle: "每回合移动",
    notificationTutorialOneMoveBody:
      "每回合按 1–6 或点击一格高亮的相邻格子，或原地不动。在同一格停留太久会耗尽土地。",
    notificationTutorialFoodOverlayTitle: "地图上的食物",
    notificationTutorialFoodOverlayBody:
      "按 F 或使用 HUD 上的谷物按钮，在已揭示格子上显示食物产量。",
    notificationTutorialLandRecoveryTitle: "土地恢复",
    notificationTutorialLandRecoveryBody: "离开后的格子会随时间恢复食物。保持迁徙，避免耗尽同一地点。",
    notificationTutorialSettingsTitle: "设置",
    notificationTutorialSettingsBody:
      "按 S 或打开齿轮可更改语言、调整音效、切换全屏、重新开始或返回标题画面。",
    notificationTutorialRandomEventsTitle: "地图事件",
    notificationTutorialRandomEventsBody:
      "探索时可能出现意外事件。按 N 或打开铃铛查看详情。",
    languageLabels: {
      en: "英语",
      it: "意大利语",
      fr: "法语",
      es: "西班牙语",
      pt: "葡萄牙语",
      de: "德语",
      zh: "中文",
      nl: "荷兰语",
    },
  },
  site: {
    gameTitle: "Dawn of Clans",
    kofiButtonLabel: "在 Ko-fi 上支持我",
    discordLinkLabel: "加入 Discord",
    landing: {
      primaryDescription:
        "Dawn of Clans 是一款大战略游戏，你将带领史前部族在生存、探索与社会演进中前行。",
      secondaryDescription:
        "从一小群游牧者起步，你将通过经验解锁技术，适应变化的环境，并塑造最早文明的诞生。",
      earlyAccessLabel: "抢先体验",
      earlyAccessNotice:
        "尚在早期开发中。核心生存循环现已可玩；更深入的策略系统仍在开发中。",
      learnMoreLabel: "了解更多",
      releaseNoticeText: "新版本刚刚发布！",
      playLabel: "开始游戏",
      continueLabel: "继续",
      savedGameSummary: "第 {turn} 回合，人口 {population}",
      resumeModalTitle: "已保存的游戏",
      newGameLabel: "新游戏",
      loadingLabel: "加载中…",
      changelogLink: "更新日志",
      careerTeaserFormat:
        "{wins} 次胜利 · 最快：{fastest} 回合 · 最多探索：{explored}",
      careerViewChronicleLabel: "查看胜利记录",
      chronicleModalTitle: "胜利记录",
      chronicleModalCloseLabel: "关闭",
      chronicleEntryFormat: "{clanName} · {turns} 回合 · {date}",
      chronicleClearWinHistoryLabel: "清除胜利记录",
      chronicleClearWinHistoryBody: "将删除此设备上保存的所有胜利记录，不会影响当前进行中的存档。",
      chronicleClearWinHistoryConfirm: "确认清除记录",
      chronicleClearWinHistoryCancel: "取消",
      settingsGearAriaLabel: "设置",
      settingsCloseAriaLabel: "关闭设置",
    },
    about: {
      pageTitle: "关于 Dawn of Clans",
      backLinkLabel: "← 返回 Dawn of Clans",
      sections: [
        {
          heading: "概览",
          body: "Dawn of Clans 是一款大战略游戏，你将带领史前部族在生存、探索与社会演进中前行。从一小群游牧者起步，你将通过经验解锁技术，适应变化的环境，并塑造最早文明的诞生。",
        },
        {
          heading: "你的部族",
          body: "新游戏开始时为你的部族命名，然后在六边形地图上选择定居地点。建立第一个定居点后，在统计面板中查看回合、人口和食物。每回合结束时为部族供食，并决定是否在进入下一回合前移动到相邻地块。",
        },
        {
          heading: "进程",
          body: "每种地形每回合产出不同数量的食物。食物储备连续若干回合保持充足时，人口会增长；若部族长期挨饿，人口会减少。在河流、平原等肥沃地块积累储备，将部族发展到 30 人即可获胜。若人口降至零，部族便已消亡。",
        },
        {
          heading: "世界",
          body: "探索六边形地图，地块初始处于隐藏状态。点击以揭示沙漠、山地、沼泽、森林、平原和河流。选择建立第一个定居点的位置，之后每回合可移动到一个相邻地块。肥沃的土地能养活更多人；恶劣的土地会迅速消耗你的食物储备。",
        },
        {
          heading: "状态",
          body: "Dawn of Clans 仍处于早期开发阶段。探索、定居、回合制食物与人口，以及胜负结果现已可玩。更深层的战略系统仍在构建中。",
        },
      ],
      communitySection: {
        heading: "社区",
        body: "在我们的 Discord 服务器上与其他玩家交流、分享反馈并关注开发动态。",
      },
      supportSection: {
        heading: "支持项目",
        body: "喜欢 Dawn of Clans？在 Ko-fi 上的自愿捐助有助于持续开发。",
      },
    },
    changelog: {
      pageTitle: "更新日志",
      backLinkLabel: "← 返回 Dawn of Clans",
      loadError: "无法加载更新日志。",
      emptyState: "尚无版本发布。",
    },
  },
};
